import React from 'react'
// import { CONSTANT } from '../../../../../../config/Constant'
// import { useAppDispatch } from '../../../../../../store/app';
// import { getGovSchemesList } from '../../utils/slice';
// import { Button, Drawer, Table } from 'antd';
// import SVGIcon from '../../../../../../utils/SVGIcon';
// import Config from '../../../../../../config/Config';
// import CancelButton from '../../../../../../components/Buttons/CancelButton';
// import { useParams } from 'react-router-dom';
import { Table } from 'antd';
import { genderOptionsDisplay } from '../../../../../../config/Global';
import { DrawerProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';


interface GovSchemeViewProps extends DrawerProps {
    // open: boolean;
    // close: () => void;
    // id: any
    // saveAndNext: any;
    // dynamicSteps: any
    govScheme: any
}

const GovSchemeView: React.FC<GovSchemeViewProps> = ({
    govScheme
}) => {
    const { t } = useTranslation();
    // const { action } = useParams();
    // const dispatch = useAppDispatch();
    // const [govSchemesList, setGovSchemesList] = useState<any>([]);
    // const [pagination, setPagination] = useState(tablePagination);

    // const continueBtn = () => {
    //     saveAndNext(CONSTANT.STEP.VILLAGE_UNAVAILABLE_SERVICES)
    // }

    // useEffect(() => {
    //     if (id && action === CONSTANT.DRAWER_TYPE.VIEW && dynamicSteps === CONSTANT.STEP.VILLAGE_GOV_SCHEMES){

    //         dispatch(getGovSchemesList({ village_id: id }))
    //         .then((res: any) => {
    //             setGovSchemesList(res.rows)
    //         })
    //         .catch((e: any) => e)
    //     }
    // }, [dynamicSteps])
    const columns:any = [
        {
            title: `${t("GENERAL.FIRST_NAME")}`,
            dataIndex: 'first_name',
            key: 'first_name',
            dataLabel:`${t("GENERAL.FIRST_NAME")}`,
            fixed:'left',
            width: 120,
        },
        {
            title: `${t("GENERAL.MIDDLE_NAME")}`,
            dataIndex: 'middle_name',
            key: 'middle_name',
            dataLabel:`${t("GENERAL.MIDDLE_NAME")}`
        },
        {
            title: `${t("GENERAL.Last_NAME")}`,
            dataIndex: 'last_name',
            key: 'last_name',
            dataLabel:`${t("GENERAL.Last_NAME")}`
        },
        {
            title: `${t("GENERAL.GENDER")}`,
            dataIndex: 'gender',
            key: 'gender',
            dataLabel:`${t("GENERAL.GENDER")}`,
            render: (text: any) => {
                return (
                    <span>{genderOptionsDisplay[text]}</span>
                )
            },
        },
        {
            title: `${t("VILLAGEMANAGEMENT.CONTECT_NUMBER")}`,
            dataIndex: 'phone',
            key: 'phone',
            dataLabel:`${t("VILLAGEMANAGEMENT.CONTECT_NUMBER")}`
        },
        {
            title: `${t("GENERAL.NAME_OF_SHCEME")}`,
            dataIndex: 'scheme_name',
            key: 'scheme_name',
            dataLabel:`${t("GENERAL.NAME_OF_SHCEME")}`
        },
        // {
        // 	title: 'Action',
        // 	key: 'action',
        // 	render: (text: any, record: any) => (
        // 		<div className='listActionbtn'>
        // 			<span onClick={() => handleAddEdit(record, "editModal")}>
        // 				<EditOutlined />
        // 			</span>
        // 			<span onClick={() => deleteModal(record)}>
        // 				<DeleteOutlined />
        // 			</span>
        // 		</div>
        // 	),
        // },
    ];
    // const drawerClose = () => {
    //     close();
    //     setGovSchemesList([])
    // };
    return (
        <Table
            dataSource={govScheme}
            columns={columns}
            pagination={false}
            scroll={{ x: 992 }}
        />
        // <Drawer
        //     title={`${VILLAGEMANAGEMENT.VILLAGE_GOV_SHCMES} ${GENERAL.VIEW__DRAWER_TITLE}`}
        //     open={open}
        //     placement="right"
        //     width={"70%"}
        //     onClose={drawerClose}
        //     destroyOnClose
        //     closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
        //     footer={[
        //         <CancelButton key={2} onClick={drawerClose} />,
        //         <Button
        //             htmlType="button"
        //             className="cancelBtn"
        //             key="2"
        //             type="primary"
        //             onClick={continueBtn}
        //         >
        //             {GENERAL.CONTINUE_BUTTON}
        //         </Button>
        //     ]}
        //     {...rest}
        // >
        //     <Table
        //         dataSource={govSchemesList}
        //         columns={columns}
        //         onChange={(pagination: any) => setPagination(pagination)}
        //         pagination={pagination} // Apply pagination configuration
        //     />
        // </Drawer>
    );
}

export default GovSchemeView